import { switchMap } from 'rxjs/operators';

import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';

import { CatalogScopeFacetsService, CatalogScopeStore } from '@mitsubishi/project/data-access';

import { LetDirective } from '@ngrx/component';

import { BrandSelectionComponent } from '../brand-selection/brand-selection.component';
import { SegmentSelectionComponent } from '../segment-selection/segment-selection.component';

/**
 * The brand and segment selects of a class-scoped page. Owns reading and writing the scope, so a page
 * only says which class it shows and what to reload when the scope changes.
 */
@Component({
  selector: 'apm-catalog-scope-filters',
  templateUrl: './catalog-scope-filters.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BrandSelectionComponent, SegmentSelectionComponent, LetDirective],
})
export class CatalogScopeFiltersComponent {
  classId = input.required<number>();
  /** The energy analysis takes its segment from the route, so it shows the brand select alone. */
  withSegment = input(true);

  brandsChanged = output<number[]>();
  segmentsChanged = output<number[]>();

  #scope = inject(CatalogScopeStore);
  #facetsService = inject(CatalogScopeFacetsService);

  facets$ = toObservable(this.classId).pipe(switchMap(classId => this.#facetsService.facetsFor(classId)));

  selectedBrands = computed(() => this.#scope.brandIds(this.classId()));
  selectedSegments = computed(() => this.#scope.segmentIds(this.classId()));

  onBrandsChanged(brandIds: number[]) {
    this.#scope.setBrandIds(this.classId(), brandIds);
    this.brandsChanged.emit(brandIds);
  }

  onSegmentsChanged(segmentIds: number[]) {
    this.#scope.setSegmentIds(this.classId(), segmentIds);
    this.segmentsChanged.emit(segmentIds);
  }
}
